import React from 'react'
import { useState } from 'react'
import ReactStars from 'react-rating-stars-component'
import { Link } from 'react-router-dom'
import ReactImageZoom from 'react-image-zoom'
import BreadCrum from '../components/BreadCrum'
import Meta from '../components/Meta'
import ProductCard from '../components/ProductCard'
import Color from '../components/Color'
import {TbGitCompare} from 'react-icons/tb'
import {AiOutlineHeart} from 'react-icons/ai'
import Container from '../components/Container'

const SingleProduct = () => {

    const props = {width:400, height:250, zoomWidth:500,img: '../images/watch.jpg'};

    const [orderedProduct, StoreOrderedProduct] = useState(true);

    const copyToClipboard = (text) => {
        var textField = document.createElement('textarea')
        textField.innerText = text 
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
    }

  return (
    <>
        <Meta title='Product Name'/>
        <BreadCrum title='Product Name' />
        <Container class1="main-product-wrapper home-wrapper-2 py-3">
            <div className="row">
                <div className="col-6">
                    <div className="main-product-image">
                        <ReactImageZoom {...props} />
                    </div>
                    <div className="other-product-images d-flex flex-wrap gap-15">
                        <div>
                            <img src="../images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                        <div>
                            <img src="../images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                        <div>
                            <img src="../images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                        <div>
                            <img src="../images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="main-product-details">
                        <div className="border-bottom">
                            <h3 className='title'>
                                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                            </h3>
                        </div>
                        <div className="border-bottom py-3">
                            <p className="price">$ 100</p>
                            <div className="d-flex align-items-center gap-10">
                                <ReactStars count={5} value={3} size={24} edit={false} activeColor="#ffd700" />
                                <p className='mb-0 t-review'>( 2 Reviews )</p>     
                            </div>
                            <a href="#review" className='review-btn'>Write a Review</a>
                        </div>
                        <div className="py-3">
                            <div className="d-flex align-items-center gap-10 my-2">
                                <h3 className='product-heading'>Type : </h3> <p className='product-data'>Watch</p>
                            </div>
                            <div className="d-flex align-items-center gap-10 my-2">
                                    <h3 className='product-heading'>Brand : </h3> <p className='product-data'>Nike</p>   
                            </div>
                            <div className="d-flex align-items-center gap-10 my-2">
                                    <h3 className='product-heading'>Category : </h3> <p className='product-data'>Watch</p>
                            </div>
                            <div className="d-flex align-items-center gap-10 my-2">
                                    <h3 className='product-heading'>Tags : </h3> <p className='product-data'>Watch</p>
                            </div>
                            <div className="d-flex align-items-center gap-10 my-2">
                                    <h3 className='product-heading'>Availablity : </h3> <p className='product-data'>In Stock</p>
                            </div>
                            <div className="d-flex flex-column gap-10 my-2">
                                    <h3 className='product-heading'>Size : </h3>
                                    <div className="d-flex flex-wrap gap-15">
                                    <div className="badge border border-1 border-secondary bg-white text-dark">S</div>           
                                    <div className="badge border border-1 border-secondary bg-white text-dark">M</div>           
                                    <div className="badge border border-1 border-secondary bg-white text-dark">L</div>           
                                    <div className="badge border border-1 border-secondary bg-white text-dark">XL</div>           
                                    </div>
                            </div>
                            <div className="d-flex flex-column gap-10 my-2">
                                    <h3 className='product-heading'>Color : </h3> 
                                    <Color />
                            </div>
                            <div className="d-flex flex-row align-items-center gap-10 my-2">
                                    <h3 className='product-heading'>Quantity : </h3> 
                                    <div>
                                    <input type="number" className='form-control' min={0}  max={10} style={{width:'70px'}} />
                                    </div>
                                <div className="d-flex align-items-center gap-30 ms-5">
                                    <button className="button border-0" type='submit'>
                                        Add to Cart
                                    </button>
                                    <button className="button signup" type='submit'>
                                        Buy it Now
                                    </button>
                                    </div>
                            </div>
                            <div className="d-flex align-items-center gap-15">
                                <div>
                                    <Link to="#">
                                        <TbGitCompare className='fs-5 me-1' /> Add to Compare
                                    </Link>
                                </div>
                                <div>
                                    <Link to="#">
                                        <AiOutlineHeart className='fs-5 me-1'/> Add to WishList
                                    </Link>
                                </div>
                            </div>
                            <div className="d-flex flex-column gap-10 my-3">
                                <h3 className='product-heading'>Shipping & Returns :</h3> 
                                <p className='product-data'>
                                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Magnam officia eius fuga nisi beatae aliquam modi eaque ipsum voluptatum voluptatem.
                                </p>
                            </div>
                            <div className="d-flex flex-column gap-10 my-3">
                                <h3 className='product-heading'>Share : </h3> 
                                <a href="javascript:void(0);" onClick={()=>copyToClipboard('https://www.facebook.com')}>
                                    Click to Copy Product Link
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
        <Container class1="description-wrapper py-5 home-wrapper-2">
            <div className="row">
                <div className="col-12">
                <h4>Description</h4>
                    <div className="bg-white p-3">  
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum assumenda sunt blanditiis enim doloremque facilis quidem dicta tempora eaque sint. Ab, temporibus! Optio dignissimos ducimus explicabo molestiae at, soluta minus laboriosam ad cupiditate libero adipisci eligendi enim earum fugit iusto veniam doloribus expedita! Corrupti recusandae dolores nobis cupiditate, ducimus sed id provident, modi natus quia rerum, officia officiis quasi accusantium fugit inventore! Sit dicta vel quaerat saepe asperiores repudiandae, quas ducimus repellat labore, error facere dolor, iusto dolore possimus. Est, eum itaque tempore magni similique dolorum eligendi ut cum laboriosam totam modi minima veniam quas quisquam, velit praesentium ipsum numquam!
                        </p>
                    </div>
                </div>
            </div>
        </Container>
        <Container class1="reviews-wrapper home-wrapper-2">
            <div className="row">
                <div className="col-12">
                    <h4>Reviews</h4>
                    <div className="review-inner-wrapper">
                        <div className="review-head d-flex justify-content-between align-items-end">
                            <div>
                                <h4 className='mb-2'>Customer Reviews</h4>
                                <div className="d-flex align-items-center gap-10">
                                    <ReactStars count={5} value={3} size={24} edit={false} activeColor="#ffd700" />
                                    <p className='mb-0'>Based on 2 Reviews</p>
                                </div>
                            </div>
                            {orderedProduct &&(
                            <div>
                                <Link className='text-decoration-underline'>write a Review</Link>
                            </div> 
                            )}
                            
                        </div>
                        <div id='review' className="review-form py-3">
                            <h4>Write a Review</h4>
                            <form action="" className="d-flex flex-column gap-15">
                                <ReactStars count={5} value={3} size={24} activeColor="#ffd700" />
                                <div>
                                <textarea name="" id="" cols="30" rows="4" className="form-control" placeholder='Your comment'></textarea>
                                </div>
                                <div className='d-flex justify-content-end'>
                                <button type='submit' className='button mb-0 border-0'>Submit Review</button>
                                </div>
                            </form>
                        </div>
                        <div className="reviews mt-2">
                            <div className="review">
                                <div className="d-flex align-items-center gap-10">
                                    <h6 className='mb-0'>Ahamd</h6>
                                    <ReactStars count={5} value={3} size={24} edit={false} activeColor="#ffd700" />
                                </div>
                                <p className='mt-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, excepturi?</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>

        <Container class1="popular-wrapper py-5 home-wrapper-2">
          <div className="row">
            <div className="col-12">
              <h3 className="section-heading">
                Our Popular Products
              </h3>
            </div>
            <ProductCard />
            <ProductCard />
            <ProductCard />
            <ProductCard />
          </div>
      </Container>
    </>
  )
}

export default SingleProduct